import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-modal" }
const _hoisted_2 = { key: 2 }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import API from "@/api";
import {
  addAppResultUsingPost,
  getAppResultByIdUsingGet,
  updateAppResultUsingPost,
} from "@/api/appResultController";
import { FILE_BIZ } from "@/constant/file";
import PictureUploader from "@/components/PictureUploader.vue";
/**
 * 定义组件属性类型
 */
interface Props {
  appId: string;
  appType: number;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AddAppResultModal',
  props: {
    appId: { default: () => "" },
    appType: { default: () => 0 }
  },
  emits: ["updateData"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const visible = ref(false);

const id = ref("");

const openModal = (appResultId: any) => {
  id.value = appResultId;
  loadData();
  visible.value = true;
};

const closeModal = () => {
  appResult.value = {};
  resultProp.value = [{ value: "" }];
  visible.value = false;
};

__expose({
  openModal,
});

const oldAppResult = ref<API.AppresultVO>();
const appResult = ref<API.AppresultAddRequest>({
  resultProp: [],
});
const resultProp = ref([{ value: "" }]);

/**
 * 加载数据
 */
const loadData = async () => {
  if (!id.value || id.value === "") {
    return;
  }
  const res = await getAppResultByIdUsingGet({ id: id.value as any });
  if (res.data.code === 200 && res.data.data) {
    oldAppResult.value = res.data.data;
    appResult.value = res.data.data;
    if (
      appResult.value.resultProp != null &&
      appResult.value.resultProp.length > 0
    ) {
      resultProp.value = appResult.value.resultProp.map((item) => {
        return {
          value: item,
        };
      });
    }
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

const handleAdd = () => {
  resultProp.value.push({ value: "" });
};

const handleDelete = (index: number) => {
  resultProp.value.splice(index, 1);
};

const emit = __emit;

const handleOk = async () => {
  appResult.value.appId = props.appId as any;
  if (resultProp.value.length > 0) {
    appResult.value.resultProp = resultProp.value.map((item) => item.value);
  }
  if (props.appType == 0) {
    // 如果是得分类
    appResult.value.resultProp = null as any;
  } else {
    // 如果是测评类
    appResult.value.resultScore = null as any;
  }
  // 如果是修改
  if (id.value) {
    const res = await updateAppResultUsingPost({
      id: id as any,
      ...appResult.value,
    });
    if (res.data.code === 200) {
      closeModal();
      message.success("修改成功");
    } else {
      message.error("修改失败，" + res.data.message);
    }
  } else {
    // 创建
    const res = await addAppResultUsingPost(appResult.value);
    if (res.data.code === 200) {
      message.success("添加成功");
      closeModal();
    } else {
      message.error("添加失败，" + res.data.message);
    }
  }
  emit("updateData");
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      onOk: handleOk,
      width: "auto"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(id.value === "" || id.value === null ? "添加结果" : "修改结果"), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: appResult.value,
          style: { width: '600px' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "结果名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: appResult.value.resultName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appResult.value.resultName) = $event)),
                  placeholder: "请输入结果名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "结果描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: appResult.value.resultDesc,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appResult.value.resultDesc) = $event)),
                  placeholder: "请输入结果描述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "结果图片" }, {
              default: _withCtx(() => [
                _createVNode(PictureUploader, {
                  biz: _unref(FILE_BIZ).APP_RESULT,
                  value: appResult.value.resultPic,
                  onChange: (value) => (appResult.value.resultPic = value)
                }, null, 8, ["biz", "value", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.appType == 0)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "结果得分"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      modelValue: appResult.value.resultScore,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appResult.value.resultScore) = $event)),
                      placeholder: "请输入结果得分"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(resultProp.value, (prop, index) => {
                  return (_openBlock(), _createBlock(_component_a_form_item, {
                    label: `结果属性 ${index + 1}`,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: prop.value,
                        "onUpdate:modelValue": ($event: any) => ((prop.value) = $event),
                        placeholder: "请输入结果属性"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (handleDelete(index)),
                        status: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Delete")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128)),
            (_ctx.appType == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_a_button, {
                    onClick: handleAdd,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("增加结果属性")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})